import { useState, useEffect, useRef, useMemo } from 'react'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { ClassicEditor, Bold, Essentials, Heading, Italic, Link, List, ListProperties, Paragraph, Table, TableCaption, TableCellProperties, TableColumnResize, TableProperties, TableToolbar, TodoList, Underline } from 'ckeditor5'

import 'ckeditor5/ckeditor5.css'
import '../css/ckEditor.css'

export default function HtmlEditor( props ) {

	const [ isLayoutReady, setIsLayoutReady ] = useState(false);

	useEffect(() => {
		setIsLayoutReady( true )
		return () => setIsLayoutReady( false )
	}, [] )

	const { editorConfig } = useMemo(() => {

		if ( !isLayoutReady ) {
			return {}
		}

		return {
			editorConfig: {
				licenseKey: 'GPL',
				toolbar: {
					items: [ 'heading', '|', 'bold', 'italic', 'underline', '|', 'link', 'insertTable', '|', 'bulletedList', 'numberedList', ],
					shouldNotGroupWhenFull: false
				},
				plugins: [ Bold, Essentials, Heading, Italic, Link, List, ListProperties, Paragraph, Table, TableCaption, TableCellProperties, TableColumnResize, TableProperties, TableToolbar, Underline ],
				heading: { options: [
					{ model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
					{ model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
					{ model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
					{ model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
				] },
				link: { addTargetToExternalLinks: true, defaultProtocol: 'https://' },
				list: { properties: { styles: true, startIndex: true, reversed: true } },
				table: { contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties'] }
			}
		}

	}, [ isLayoutReady ]);

	return <div>
		<div className="editor-container editor-container_classic-editor" >
			<div className="editor-container__editor">
				{ editorConfig && <CKEditor 
					editor={ ClassicEditor } 
					config={ editorConfig } 
				    data={ props.value || '' }
				    onChange={ props.onChange }
				/> }
			</div>
		</div>
	</div>
}

